import React from 'react';

function VendorManagement({ newVendorName, setNewVendorName, handleAddVendor, vendors }) {
    return (
        <div className="mb-8 p-4 border rounded-md bg-white shadow-sm">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">Vendor Management</h2>

            {/* Add New Vendor Form */}
            <div className="mb-6 p-4 border rounded-md bg-gray-50">
                <h3 className="text-xl font-semibold mb-3 text-gray-800">Add New Vendor</h3>
                <div className="flex flex-col sm:flex-row gap-3">
                    <input
                        type="text"
                        value={newVendorName}
                        onChange={(e) => setNewVendorName(e.target.value)}
                        placeholder="Enter new vendor name"
                        className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                        onClick={handleAddVendor}
                        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
                    >
                        Add Vendor
                    </button>
                </div>
            </div>

            {/* List of Existing Vendors */}
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Existing Vendors</h3>
            {vendors.length === 0 ? (
                <p className="text-gray-600 text-center">No vendors found. Add one above!</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Vendor ID
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Vendor Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Avg. Rating (1-5)
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Total Products
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Total Reviews
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Added On
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {vendors.map((vendor) => (
                                <tr key={vendor.vendor_id}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        {vendor.vendor_id}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        {vendor.vendor_name}
                                    </td>
                                    {/* Display 'N/A' if no reviews, otherwise display the formatted average rating */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-blue-700">
                                        {vendor.total_reviews_count > 0 ? vendor.average_vendor_rating : 'N/A'}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {vendor.total_products_count}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {vendor.total_reviews_count}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {vendor.created_at ? new Date(vendor.created_at).toLocaleString() : 'N/A'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default VendorManagement; 